import * as React from 'react';

const AddressInput = (): React.ReactElement => {
  return <div>TODO: AddressInput</div>;
};

export default AddressInput;
